import {union, map, emptyArray, moment, createSelector, createStructuredSelector} from 'helpers';
import {id, today, createdDate} from 'store/common';
import {goals, milestonesById} from './goals';
import {images} from 'store/files/selectors';
import {collaboration, editable} from 'store/relations';
import {saved} from 'store/server';
import {byGoalId as activitiesByGoalId} from 'store/activities/selectors';
import {byGoalId as diaryByGoalId} from 'store/diary';

export const goal = createSelector(
  [goals, id],
  (goals, id = '') => goals[id],
);

const timeframe = createSelector(
  [goal, today],
  (goal, today) => {
    if (goal && goal.target_date) {
      const diff = moment.unix(goal.target_date).diff(today, 'days');
      return diff < 0 ? 'past' : (diff < 30 ? 'close' : 'future');
    }
  }
);

const project = createSelector(
  [goal, state => state.goals.types],
  (goal, projects) => goal && projects[goal.typeId],
);

const parentGoal = createSelector(
  [goal, goals],
  (goal, goals) => goal && goals[goal.parent_id ?? '']
);

export const starting_date = createSelector(
  [goal],
  (goal) => goal && (goal.starting_date || createdDate(goal)),
);

export const target_date = createSelector(
  [goal],
  (goal) => goal && goal.target_date,
);

export const milestones = createSelector(
  [id, milestonesById],
  (id, milestonesById) => (milestonesById[id ?? ''] || []).filter(milestone => milestone.id != id),
  {memoizeOptions: {maxSize: 100}},
);

export const activities = createSelector(
  [id, activitiesByGoalId],
  (id, activitiesByGoalId) => activitiesByGoalId[id ?? ''] || emptyArray,
);

const diary = createSelector(
  [id, diaryByGoalId],
  (id, diaryByGoalId) => diaryByGoalId[id ?? ''] || emptyArray,
);

export const allActivities = createSelector(
  [id, milestonesById, activitiesByGoalId],
  (id, milestonesById, activitiesByGoalId) => union.apply(null, map(milestonesById[id ?? ''], milestone => activitiesByGoalId[milestone.id])),
  {memoizeOptions: {maxSize: 100}},
);

export const details = createStructuredSelector({
  activities,
  allActivities,
  collaboration,
  diary,
  editable,
  goal,
  images,
  milestones,
  parentGoal,
  project,
  saved,
  starting_date,
  target_date,
  timeframe,
});
